// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"0f3e4f3f","513":"d9bf0ba4","703":"ee4b25d5"}[chunkId] + ".chunk.js";
};